<template>
    <div>
        <a-card :title="$t('descriptions.bgm')" :bordered="false">
            <global-single @handleSubmit="saveBgm" @handleCancel="cancelBgm">
                <template v-slot:global>
                    <div>
                        <AdsItem
                                :url="form.bgm"
                                frame-type="audio"
                                :title="''"
                                :isEdit="true"
                                :width="'300px'"
                                @updateData="updateBgm"
                                @deleteData="deleteBgm"
                        ></AdsItem>
                    </div>
                </template>
                <template v-slot:single>
                    <div class="sence-list">
                        <div class="list-item" v-for="(item,index) in senceList" :key="index">
                            <div class="sence-img">
                                <img :src="item.thumb_path"/>
                            </div>
                            <div class="sence-title">{{item.scene_title}}</div>
                            <div class="sence-bgm">
                                <audio
                                        controls="controls"
                                        alt="example"
                                        :src="item.bg_music.bgm?item.bg_music.bgm:''"
                                ></audio>
                            </div>
                            <div class="sence-bgm-btn">
                                <material-select :type="2" @selected="updateSingleBgm">
                                    <template slot="body">
                                        <a-button type="primary" @click="clickSingleBgm(index)">
                                            {{$t('actionTitles.changeCover')}}
                                        </a-button>
                                    </template>
                                </material-select>
                                <a-button type="danger" v-if="item.bg_music.bgm && item.bg_music.bgm!=''" style="margin-left: 10px" @click="deleteSingleBgm(index)">
                                    {{$t('actionTitles.delete')}}
                                </a-button>
                            </div>
                        </div>
                    </div>
                </template>
            </global-single>
        </a-card>
    </div>
</template>

<script>
    import GlobalSingle from "./GlobalSingle";
    import MaterialSelect from "@/components/MaterialSelect";
    import AdsItem from "./AdsItem";
    import {
        mapGetters
    } from "vuex";
    export default {
        name: "BgmView",
        components:{ GlobalSingle,MaterialSelect,AdsItem },
        computed: {
            ...mapGetters(["vrbase", "userInfo"])
        },
        data() {
            return {
                senceList:[],
                form:{
                    bgm:''
                },
                curSingleSenceId:''
            }
        },
        created() {
            this.senceList = this.$deepClone(this.vrbase.scenes)
            this.form = this.$deepClone(this.vrbase.ads);
        },
        methods: {
            updateBgm(data) {
                this.form.bgm = data.url;
            },
            deleteBgm() {
                this.form.bgm = ''
            },
            clickSingleBgm(index){
                this.curSingleSenceId=index
            },
            updateSingleBgm(data){
                this.$set(this.senceList[this.curSingleSenceId].bg_music, "bgm", data.url)
            },
            deleteSingleBgm(index){
                this.curSingleSenceId=index
                this.senceList[this.curSingleSenceId].bg_music.bgm = ''
            },
            saveBgm(){
                const vrbase = {...this.vrbase, ads: this.form,scenes: this.senceList}
                this.$store.dispatch("saveVRBase", {
                    vrbase,
                    showLoading: true,
                }, true);
            },
            cancelBgm(){
                this.senceList = this.$deepClone(this.vrbase.scenes)
                this.form = this.$deepClone(this.vrbase.ads);
            }
        },
    }
</script>

<style lang="less" scoped>
    .list-item{
        background-color: #2f2f2f;
        border: 1px solid #555;
        padding: 20px;
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        .sence-img{
            width: 70px;
            height: 70px;
            flex-shrink: 0;
            img{
                width: 70px;
                height: 70px;
                object-fit: contain;
            }
        }
        .sence-title{
            flex: 1;
            margin: 0 20px;
            overflow: hidden;
            word-wrap:break-word;
        }
        .sence-bgm{
            flex-shrink: 0;
            margin-right: 20px;
        }
        .sence-bgm-btn{
            width: 140px;
            flex-shrink: 0;
            display: flex;
            .changeCoverBtn {
                background-color: #7101ad;
                border-color: #7101ad;
            }
        }
    }
</style>
